var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isMobile && _vm.terminalMode === "false"
        ? _c("DesktopView")
        : _vm._e(),
      _vm.terminalMode === "true" ? _c("TabletView") : _vm._e(),
      _vm.isMobile && _vm.terminalMode === "false"
        ? _c("MobileView")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }